<app-form-card
  titleIcon="3p"
  cardTitle="CONTACT.HEADING"
  description="CONTACT.DESCRIPTION"
  dataTestId="contact-heading"
>
  <form [formGroup]="contactForm">
    <h2 appRequiredSuffix>
      {{ "CONTACT.CONNECTION_HOLDER_TITLE" | translate }}
    </h2>
    <app-contact-section
      [parentFormGroup]="contactForm.get('basicData')! | castToFormGroup"
      category="connection-holder"
    />

    <div class="space"></div>

    <h2 appRequiredSuffix>
      {{ "CONTACT.DIFFERENT_REQUESTER_ADDRESS" | translate }}
    </h2>

    <mat-radio-group
      color="primary"
      formControlName="hasDifferentAddress"
      class="input-container"
    >
      <div>
        <mat-radio-button [value]="false" data-testid="same-address">{{
          "COMMON.YES" | translate
        }}</mat-radio-button>
        <mat-radio-button [value]="true" data-testid="different-address">
          {{ "COMMON.NO" | translate }}
        </mat-radio-button>
      </div>

      <mat-error
        [hideError]="!allTouched"
        appErrorMessages="hasDifferentAddress"
      />
    </mat-radio-group>

    @if (contactForm | formLookup: "hasDifferentAddress") {
      <h2 appRequiredSuffix>
        {{ "CONTACT.RESIDENTIAL_ADDRESS_TITLE" | translate }}
      </h2>

      <app-address-section
        [parentFormGroup]="
          contactForm.get('differentAddress')! | castToFormGroup
        "
        category="residential-address"
        data-testid="address-form"
      />
      <div class="space"></div>
    }

    <h2 appRequiredSuffix>
      {{ "CONTACT.ROLE.TITLE" | translate }}
    </h2>

    <mat-radio-group
      color="primary"
      formControlName="role"
      class="input-container"
    >
      @for (role of roleTypes; track role) {
        <mat-radio-button [value]="role" [attr.data-testid]="role">{{
          "CONTACT.ROLE.TYPES." + role | translate
        }}</mat-radio-button>
      }
      <mat-error [hideError]="!allTouched" appErrorMessages="role" />
    </mat-radio-group>

    @if (contactForm | formLookup: "role") {
      @if (
        (contactForm | formLookup: "role") === roles.AUTHORIZED_REPRESENTATIVE
      ) {
        <div class="input-container">
          <mat-form-field appearance="outline" class="input-field">
            <mat-label>{{ "CONTACT.YOUR_ROLE" | translate }}</mat-label>
            <input
              matInput
              type="text"
              name="authorizedRepresentativeRole"
              formControlName="authorizedRepresentativeRole"
              data-testid="authorized-representative-role"
            />
            <mat-error appErrorMessages="authorizedRepresentativeRole" />
          </mat-form-field>
        </div>
        <div class="space"></div>
      }

      @if ((contactForm | formLookup: "role") !== roles.CONNECTION_HOLDER) {
        <h2 appRequiredSuffix>
          {{ "CONTACT.YOUR_CONTACT_DETAILS" | translate }}
        </h2>

        <app-contact-section
          [parentFormGroup]="
            contactForm.get('onBehalfContactDetails.basicData')!
              | castToFormGroup
          "
          category="on-behalf"
          data-testid="on-behalf-contact-form"
        />

        @if ((contactForm | formLookup: "role") === roles.INSTALLER) {
          <div class="input-container" formGroupName="installerDetails">
            <mat-form-field appearance="outline" class="input-field">
              <mat-label>{{
                "CONTACT.INSTALLER.GRID_OPERATOR" | translate
              }}</mat-label>
              <input
                matInput
                type="text"
                name="gridOperator"
                formControlName="gridOperator"
                data-testid="grid-operator"
              />
              <mat-error appErrorMessages="gridOperator" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-field">
              <mat-label>{{
                "CONTACT.INSTALLER.REGISTRATION_NUMBER" | translate
              }}</mat-label>
              <input
                matInput
                type="text"
                name="registrationNumber"
                formControlName="registrationNumber"
                data-testid="registration-number"
              />
              <mat-error appErrorMessages="registrationNumber" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-field">
              <mat-label>{{
                "CONTACT.INSTALLER.COMPANY_NAME" | translate
              }}</mat-label>
              <input
                matInput
                type="text"
                name="companyName"
                formControlName="companyName"
                data-testid="company-name"
              />
              <mat-error appErrorMessages="companyName" />
            </mat-form-field>
          </div>
        }

        <app-address-section
          [parentFormGroup]="
            contactForm.get('onBehalfContactDetails.address')! | castToFormGroup
          "
          category="on-behalf-address"
        />

        <div class="space"></div>

        <h2 appRequiredSuffix>
          {{ "CONTACT.POWER_OF_ATTORNEY.TITLE" | translate }}
        </h2>

        <mat-checkbox
          [formControl]="
            contactForm.get('onBehalfContactDetails.powerOfAttorney')!
              | castToFormControl
          "
          color="primary"
          class="input-field power-of-attorney-checkbox"
          data-testid="power-of-attorney"
        >
          <mat-label appRequiredSuffix>
            {{ "CONTACT.POWER_OF_ATTORNEY.DECLARATION" | translate }}
          </mat-label>
        </mat-checkbox>
        <mat-error
          [hideError]="
            contactForm.get('onBehalfContactDetails.powerOfAttorney')!.untouched
          "
          appErrorMessages="onBehalfContactDetails.powerOfAttorney"
        />
        @if (
          contactForm | formLookup: "onBehalfContactDetails" : "powerOfAttorney"
        ) {
          <app-document-upload-section
            [allTouched]="allTouched"
            [documentDetails]="powerOfAttorneyDocumentDetails"
            [documentControl]="
              contactForm.get('onBehalfContactDetails.powerOfAttorneyDocument')!
                | castToFormControl
            "
            [multipleDocumentUpload]="false"
            [hideDocumentName]="true"
            documentControlName="powerOfAttorneyDocument"
            documentDescription="CONTACT.POWER_OF_ATTORNEY.DOCUMENT"
          />
        }
      }
    }
  </form>

  <app-form-navigation
    (previous)="previous()"
    (next)="next()"
    [nextConfig]="{
      disabled: allTouched | nextButtonDisabled: contactForm.invalid,
    }"
    slot="navigation"
  />
</app-form-card>
